import Guid from "_shared/guids/guid";
import AHDate from "_shared/dates/date";
import NetworkedGroupSchema, { NetworkedGroupJSON, NetworkedGroupParams } from "users/networking/groups/_schemas/networked-group-schema";
import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";

export default class NetworkedGroup {
  public static readonly EXAMPLE: NetworkedGroup = NetworkedGroup.create({
    id: Guid.generate(),
    name: "Test Group",
    description: "This is a test networked group.",
    memberUserIds: [
      Guid.generate(),
      Guid.generate()
    ],
    created: new AHDate()
  });

  public static create(values: NetworkedGroupParams): NetworkedGroup {
    const parsed = NetworkedGroupSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid NetworkedGroup parameters.");
    }
    return new NetworkedGroup(parsed);
  }

  public static fromJSON(json: NetworkedGroupJSON): NetworkedGroup {
    if (isNullOrUndefined(json)) return json;
    const params = NetworkedGroupSchema.deserialize(json);
    return new NetworkedGroup(params);
  }

  public static fromJSONArray(jsonArray: NetworkedGroupJSON[]): NetworkedGroup[] {
    return jsonArray.map(json => NetworkedGroup.fromJSON(json));
  }

  public readonly id: Guid;
  public readonly created: AHDate;
  public readonly name?: string;
  public readonly description?: string;
  public readonly memberUserIds: Guid[] = [];
  public readonly version: string;

  public constructor(params: NetworkedGroupParams) {
    this.id = params.id;
    this.name = params.name;
    this.description = params.description;
    this.memberUserIds = params.memberUserIds;
    this.version = params.version ?? "";
    this.created = params.created;
  }

  public toJSON(): NetworkedGroupJSON {
    return NetworkedGroupSchema.serialize(this);
  }

  public isEqualTo(other: NetworkedGroup): boolean {
    return this.id.isEqualTo(other.id);
  }

  public toString(): string {
    return `NetworkedGroup { 
      id: ${this.id.toString()}, 
      name: ${this.name},
      description: ${this.description},
      memberUserIds: [${this.memberUserIds.map(id => id.toString()).join(", ")}],
      created: ${this.created.toString()}
    }`;
  }
}
